import { z } from 'zod'

export const benefitAndVoucherManagementGetPromoCodeSchema = z.object({
  promoCode: z.string().nullable()
})

export interface BenefitAndVoucherManagementGetPromoCode
  extends z.infer<typeof benefitAndVoucherManagementGetPromoCodeSchema> {}
